import type { EntityDto } from '@app/api/dtos'
import type { SelectFc } from '@app/types/QueryOptions'
import type { FilterOption } from '@app/types/filter'

export const getFilterFromEntitiesToLabelsIds: SelectFc<FilterOption, EntityDto> = entityResponse =>
  entityResponse?.map(({ id }) => ({
    value: id,
    label: id
  })) ?? []
